
type Props<T extends string> = {
  models: Record<T, string>
  value: T
  onChange: (value: T) => void
}

export default function ModelSelect<T extends string>({
  models,
  value,
  onChange
}: Props<T>) {
  return (
    <div className="mt-4">
      <label className="block font-medium mb-2">
        Model
      </label>

      <select
        className="w-full border rounded p-2"
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
      >
        {(Object.keys(models) as T[]).map((model) => (
          <option key={model} value={model}>
            {models[model]}
          </option>
        ))}
      </select>
    </div>
  )
}